// GRNLineasXL - Sprint 44 Fase 3 Vista 9.
// Tabla lineas GRN con cantidad_po, cantidad_recibida (editable), diferencia
// calculada, badge estado linea (ok/faltante/sobrante). Refactor de
// GRNForm.jsx legacy (que tenia 346L).
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../design/motion';
import XLBadge from '../../components/xl/XLBadge';

const CSS_ID = 'xl-grn-lineas-css';
const CSS = `
.xl-grnl { font-family: var(--xl-font-sans) }
.xl-grnl__title {
  display: flex; align-items: baseline; gap: 12px;
  font-size: 13px; font-weight: 600; color: var(--xl-color-text);
  margin: 0 0 12px;
}
.xl-grnl__counts {
  display: inline-flex; align-items: center; gap: 8px;
  font-size: 11px; font-weight: 400;
  color: var(--xl-color-text-secondary);
}
.xl-grnl__count-num { font-family: var(--xl-font-mono); font-weight: 600 }
.xl-grnl__count--ok    { color: var(--xl-color-success) }
.xl-grnl__count--fal   { color: var(--xl-color-danger) }
.xl-grnl__count--sob   { color: var(--xl-color-warning) }

.xl-grnl__table-wrap {
  overflow-x: auto;
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-lg);
  background: var(--xl-color-surface);
  box-shadow: var(--xl-shadow-sm);
}
.xl-grnl__table { width: 100%; min-width: 720px; border-collapse: collapse; font-size: 13px }
.xl-grnl__table thead th {
  background: var(--xl-color-bg); color: var(--xl-color-text-secondary);
  font-size: 11px; font-weight: 600;
  text-transform: uppercase; letter-spacing: 0.05em;
  text-align: left; padding: 10px 12px;
  border-bottom: 1px solid var(--xl-color-border);
  white-space: nowrap;
}
.xl-grnl__table td { padding: 10px 12px; border-bottom: 1px solid var(--xl-color-border); color: var(--xl-color-text) }
.xl-grnl__table tr:last-child td { border-bottom: 0 }

.xl-grnl__prod-name { font-weight: 500 }
.xl-grnl__prod-code { font-family: var(--xl-font-mono); font-size: 10px; color: var(--xl-color-text-muted); margin-top: 2px }

.xl-grnl__numinp {
  width: 96px;
  font: 400 13px/1.4 var(--xl-font-mono);
  color: var(--xl-color-text);
  background: var(--xl-color-bg);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-sm);
  padding: 6px 8px;
  text-align: right; box-sizing: border-box;
}
.xl-grnl__numinp:focus { outline: none; border-color: var(--xl-color-focus); box-shadow: 0 0 0 3px rgba(37,99,235,0.18) }
[data-xl-theme="dark"] .xl-grnl__numinp:focus { box-shadow: 0 0 0 3px rgba(96,165,250,0.28) }

.xl-grnl__empty { padding: 32px 16px; text-align: center; color: var(--xl-color-text-muted); font-size: 13px }
.xl-mono { font-family: var(--xl-font-mono); font-size: 12px }
.xl-td-right { text-align: right }
`;

const ESTADO_VARIANT = {
  ok: 'success', faltante: 'danger', sobrante: 'warning',
};
const ESTADO_LABEL = {
  ok: 'OK', faltante: 'Faltante', sobrante: 'Sobrante',
};

export default function GRNLineasXL({ lineas, onLocal, onSave }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);

  const tot_ok = lineas.filter((l) => l.estado_linea === 'ok').length;
  const tot_fal = lineas.filter((l) => l.estado_linea === 'faltante').length;
  const tot_sob = lineas.filter((l) => l.estado_linea === 'sobrante').length;

  return (
    <div className="xl-grnl">
      <h3 className="xl-grnl__title">
        Lineas recibidas ({lineas.length})
        <span className="xl-grnl__counts">
          <span className="xl-grnl__count--ok">
            <span className="xl-grnl__count-num">{tot_ok}</span> ok
          </span>
          <span className="xl-grnl__count--fal">
            <span className="xl-grnl__count-num">{tot_fal}</span> faltante
          </span>
          <span className="xl-grnl__count--sob">
            <span className="xl-grnl__count-num">{tot_sob}</span> sobrante
          </span>
        </span>
      </h3>

      {lineas.length === 0 && (
        <div className="xl-grnl__empty">El GRN no tiene lineas.</div>
      )}

      {lineas.length > 0 && (
        <div className="xl-grnl__table-wrap">
          <table className="xl-grnl__table">
            <thead>
              <tr>
                <th>Producto</th>
                <th className="xl-td-right">Cant. PO</th>
                <th className="xl-td-right">Cant. recibida</th>
                <th className="xl-td-right">Diferencia</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {lineas.map((l) => {
                const dif = (Number(l.cantidad_recibida || 0) - Number(l.cantidad_po || 0)).toFixed(2);
                return (
                  <tr key={l.id}>
                    <td>
                      <div className="xl-grnl__prod-name">{l.producto_descripcion || '\u2014'}</div>
                      {l.producto_codigo && <div className="xl-grnl__prod-code">{l.producto_codigo}</div>}
                    </td>
                    <td className="xl-td-right xl-mono">{l.cantidad_po}</td>
                    <td className="xl-td-right">
                      <input type="number" min="0" step="0.01" className="xl-grnl__numinp"
                        value={l.cantidad_recibida || 0}
                        onChange={(e) => onLocal(l.id, 'cantidad_recibida', e.target.value)}
                        onBlur={() => onSave(l)} />
                    </td>
                    <td className="xl-td-right xl-mono">{dif}</td>
                    <td>
                      <XLBadge variant={ESTADO_VARIANT[l.estado_linea] || 'neutral'} dot>
                        {ESTADO_LABEL[l.estado_linea] || l.estado_linea || '\u2014'}
                      </XLBadge>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
